import { APIService } from "./api";
import { API } from "@/lib/api";
import { ReadProjectType, CreateProjectType } from "@/types/projectType";

export const ProjectTypesService = new APIService<
  ReadProjectType,
  CreateProjectType
>(API.ProjectTypes);
export const fetchProjectTypeList = ProjectTypesService.getList;
export const fetchProjectType = ProjectTypesService.get;
export const createProjectType = ProjectTypesService.post;
export const updateProjectType = ProjectTypesService.patch;
